import { HTMLAttributes } from "react";

import styled, { css } from "styled-components";

import { ConfirmDeleteContainer } from "pages/[tenant]/feed/components/atoms/DeleteFeedEntity/styles";
import { feedPageBreakpoints } from "pages/[tenant]/feed/utils/feedPageBreakpoints";

export interface IFeedPostContainerContainerProps
  extends HTMLAttributes<HTMLDivElement> {
  isFixed?: boolean;
}

export const FeedPostContainerContainer = styled.div<IFeedPostContainerContainerProps>`
  border: 1.5px solid ${({ theme }) => theme.feed.postBorderColor};
  background-color: ${({ theme }) => theme.feed.postBackgroundColor};

  border-radius: 4px;

  padding: 1rem;

  :has(${ConfirmDeleteContainer}, div[data-is-options-open="true"]) {
    position: relative;
    z-index: 2;
  }

  display: grid;
  gap: 0.5rem;
  grid-template-areas:
    "user options"
    "content content"
    "interactions interactions";
  grid-template-rows: auto auto;

  backdrop-filter: blur(8px);

  @media (max-width: ${feedPageBreakpoints.hd}px) {
    backdrop-filter: initial;
  }

  ${({ isFixed }) =>
    isFixed &&
    css`
      border-top: 2px solid ${({ theme }) => theme.feed.fixedPostBorderColor};
    `}
`;
